import { Grid } from "@mui/material";
import { Button, SimpleForm } from "react-admin";
import StudyGroupField from "server/components/Fields/StudyGroupField";
import CloseIcon from "@mui/icons-material/Close";
import SaveButtonStudyGroups from "./SaveButtonStudyGroups";

const StudyGroupsForm = ({ setIsEditStudyGroups, record }) => {
  return (
    <Grid
      item
      xs={12}
      md={6}
    >
      <SimpleForm
        toolbar={false}
        defaultValues={record}
        sx={{ pt: 0, pl: 0 }}
      >
        <StudyGroupField label=" Пример за въвеждане на Учебни групи: 1-5, 8, 11-13, 15. Оставете празно ако изпита се отнася за всички групи!" />
        <Grid
          item
          xs={12}
          sx={{ display: "flex", gap: 3, mt: 2 }}
        >
          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            color="error"
            size="small"
            label="Откажи"
            onClick={() => setIsEditStudyGroups(false)}
          />
          <SaveButtonStudyGroups setIsEditStudyGroups={setIsEditStudyGroups} />
        </Grid>
      </SimpleForm>
    </Grid>
  );
};
export default StudyGroupsForm;
